import { createContext, FC, ReactElement, useState } from 'react'
import { ThemeProvider } from './ThemeProvider'
import { Box, CircularProgress, Container, Typography } from '@mui/material'
import NetworkProvider from './NetworkProvider'

export const AppLoading: FC = () => {
  return (
    <Container maxWidth="lg">
      <Box display="flex" flexDirection="column" alignItems="center" pt={5}>
        <Typography variant="h6">...just a sec...</Typography>
        <Box mt={4}>
          <CircularProgress size={100} />
        </Box>
      </Box>
    </Container>
  )
}

export type AppConfig = {
  buildEnv: string
  debug: boolean
  mockAPI: boolean
  curriculumURL: string
  apiBaseURL: string
}
export const CONFIG: AppConfig = {
  buildEnv: process.env.REACT_APP_ENV || 'dev',
  debug: Boolean(process.env.REACT_APP_DEBUG),
  mockAPI: Boolean(process.env.REACT_APP_MOCK_API),
  curriculumURL: process.env.CURRICULUM_URL || '',
  apiBaseURL: process.env.REACT_APP_BASE_API || ''
}

export interface AppSettings {
  config: AppConfig
  isLoaded: boolean
}
const initialSettings = {
  config: CONFIG,
  isLoaded: false,
}

export interface IAppContext {
  appSettings: AppSettings
  setAppSettings: React.Dispatch<React.SetStateAction<AppSettings>>
  config: AppConfig
  isLoaded: boolean
}
export const AppContext = createContext({
  setAppSettings: () => {},
  appSettings: {} as AppSettings,
  config: {} as AppConfig,
  isLoaded: initialSettings.isLoaded,
} as IAppContext)
export interface AppProviderProps {
  children: ReactElement | ReactElement[]
}
export const AppProvider: FC<AppProviderProps> = ({ children }) => {
  const [appSettings, setAppSettings] = useState(initialSettings)
  const contextValues = {
    appSettings,
    setAppSettings,
    config: appSettings.config,
    isLoaded: appSettings.isLoaded,
  }

  

  return (
    <AppContext.Provider value={contextValues}>
      <ThemeProvider>
        <NetworkProvider>
          {!appSettings.isLoaded ? <AppLoading /> : children}
        </NetworkProvider>
      </ThemeProvider>
    </AppContext.Provider>
  )
}

export default AppProvider
